(() => {
 function init(root = document) {
  root.querySelectorAll('[data-jp-slideshow-v1]').forEach(el => {
   if(el.dataset.jpSlideshowReady) return;
   const track=el.querySelector('[data-jp-track]');
   if(!track) return;
   const slides=[...track.children];
   if(!slides.length)return;
   el.dataset.jpSlideshowReady='true';
   let index=0,startX=0,startY=0,swiped=false;
   function show(value,direction=1) {
    index=(value+slides.length)%slides.length;
    el.style.setProperty('--jp-slide-direction',direction>0?'1':'-1');
    slides.forEach((slide,i)=>{
     const active=i===index;
     slide.classList.toggle('jp-slide-current',active);
     slide.inert=!active;
     slide.setAttribute('aria-hidden',String(!active));
    });
   }
   const prev=el.querySelector('[data-jp-prev]'),next=el.querySelector('[data-jp-next]');
   prev?.addEventListener('click',()=>show(index-1,-1));
   next?.addEventListener('click',()=>show(index+1,1));
   if(slides.length<2){if(prev)prev.hidden=true;if(next)next.hidden=true;}
   track.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;startY=e.touches[0].clientY;},{passive:true});
   track.addEventListener('touchend',e=>{
    const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;
    if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){
     const direction=dx<0?1:-1;show(index+direction,direction);
     swiped=true;setTimeout(()=>swiped=false,400);
    }
   },{passive:true});
   track.addEventListener('click',e=>{if(swiped)e.preventDefault();});
   show(0);el.classList.add('jp-slideshow-enhanced');
   // Cadência fixa: mouse, foco e setas não interrompem nem reiniciam os 3s.
   const timer=slides.length>1?setInterval(()=>{
    if(!el.isConnected){clearInterval(timer);return;}
    if(!document.hidden)show(index+1,1);
   },3000):null;
   const unload=e=>{
    if(!e.target.contains(el))return;
    if(timer)clearInterval(timer);
    document.removeEventListener('shopify:section:unload',unload);
   };
   document.addEventListener('shopify:section:unload',unload);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
 else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
